import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';

export interface EditUserRolesDialogData {
  user: { first_name?: string; last_name?: string; username?: string; email?: string; roles?: string[] };
  availableRoles: string[];
}

@Component({
  selector: 'app-edit-user-roles-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,
    TextPrettyPipe,
  ],
  template: `
    <div class="erd">
      <div class="erd-h">
        <span class="ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
               stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M19 8v6"/><path d="M16 11h6"/>
          </svg>
        </span>
        <div class="erd-htext">
          <div class="erd-title">Edit roles</div>
          <div class="erd-sub">{{ data.user?.email }}</div>
        </div>
      </div>

      <div class="erd-b">
        <label class="erd-label">Roles</label>
        <mat-form-field appearance="outline" class="erd-field">
          <mat-select [(value)]="selectedRoles" multiple panelClass="edit-roles-panel">
            <mat-option *ngFor="let role of data.availableRoles" [value]="role">
              {{ role | textpretty | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p class="erd-help">Select one or more roles to grant this user.</p>
      </div>

      <div class="erd-f">
        <button type="button" class="btn-ghost" [mat-dialog-close]="null">Cancel</button>
        <button type="button" class="btn-primary" (click)="save()">Save</button>
      </div>
    </div>
  `,
  styles: [`
    :host{
      --brand:#E60000;--brand-d:#B80000;--ink:#1A1A1A;--muted:#6B7280;--line:#E5E7EB;
      font-family:'Inter',system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif;
    }
    .erd{min-width:380px;max-width:460px;color:var(--ink)}
    .erd-h{display:flex;gap:14px;align-items:center;padding:20px 22px 14px}
    .ico{width:38px;height:38px;border-radius:10px;display:flex;align-items:center;
      justify-content:center;flex-shrink:0;background:#FDECEC;color:var(--brand)}
    .erd-title{font-size:17px;font-weight:700;line-height:1.3}
    .erd-sub{font-size:13px;color:var(--muted);margin-top:2px;
      overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:330px}
    .erd-b{padding:4px 22px 14px}
    .erd-label{display:block;font-size:13px;font-weight:700;margin-bottom:7px}
    .erd-field{width:100%}
    .erd-help{color:var(--muted);font-size:12.5px;margin:6px 0 0}
    .erd-f{display:flex;justify-content:flex-end;gap:10px;padding:14px 22px;
      border-top:1px solid var(--line);background:#FCFCFD}
    .btn-ghost{background:#fff;color:#374151;border:1px solid var(--line);border-radius:9px;
      padding:0 18px;height:38px;font-size:14px;font-weight:600;cursor:pointer}
    .btn-ghost:hover{background:#F9FAFB}
    .btn-primary{background:var(--brand);color:#fff;border:none;border-radius:9px;
      padding:0 18px;height:38px;font-size:14px;font-weight:600;cursor:pointer}
    .btn-primary:hover{background:var(--brand-d)}
    /* tighten the outlined select so it fits the compact dialog */
    ::ng-deep .erd-field .mat-mdc-form-field-subscript-wrapper{display:none}
  `],
})
export class EditUserRolesDialogComponent {
  selectedRoles: string[];

  constructor(
    public dialogRef: MatDialogRef<EditUserRolesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditUserRolesDialogData
  ) {
    this.selectedRoles = Array.isArray(data?.user?.roles)
      ? [...(data.user.roles as string[])]
      : [];
  }

  save(): void {
    this.dialogRef.close(this.selectedRoles);
  }
}
